import React, { ReactElement } from "react";
import MainBanner from "@components/comparecrmprices/mainBanner";
import CompareCRMPricesWrapper from "@components/layouts/compareCrmPricesWrapper";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";

const WhyUs = dynamic(() => import("@components/comparecrmprices/whyUs"));

const OffersList = dynamic(() => import("@components/shared/offersList"));

export default function CompareCRMPricesHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <CompareCRMPricesWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <WhyUs />
        </CompareCRMPricesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
